import { Injectable, signal } from "@angular/core";
import { SaleInArea } from "src/models/estate/IResidenceSaleInArea";

@Injectable()
export class EstateSaleItemHoverService {
    estateSaleItemHoverSignal = signal<SaleInArea[]>([]);

    setHover(h: SaleInArea[]) {
        this.estateSaleItemHoverSignal.set(h);
    }

    isHoverdBasedOnUnitId(sale: SaleInArea) {
       return this.estateSaleItemHoverSignal().findIndex((s) => s.unitId === sale.unitId) !== -1;
    }
}
